import apiClient from './ApiClient'

export default {
  dodajResurs(resurs) {
    //debugger
    let formData = new FormData()
    formData.append('tip', resurs.tip)
    formData.append('naslov', resurs.naslov)
    formData.append('datum', resurs.datum ? resurs.datum : '')
    formData.append('tekst', resurs.tekst ? resurs.tekst : '')

    for (let i = 0; i < resurs.elementi.length; i++) {
      var element = resurs.elementi[i]
      var file = element.file
      var filename = element.tekst
      //var tip = element.tip
      var id = element.id

      // u Form data dodajemo key/value
      // value moze biti string ili blob(file)
      if (file) {
        formData.append(id, file, filename) // file
      }
      formData.append('elementi[]', JSON.stringify(element)) // string
    }

    return apiClient.post('/resurs', formData)
  },
  izmeniResurs(resurs) {
    //console.log(resurs)
    let formData = new FormData()
    formData.append('tip', resurs.tip)
    formData.append('naslov', resurs.naslov)
    formData.append('datum', resurs.datum ? resurs.datum : '')
    formData.append('tekst', resurs.tekst ? resurs.tekst : '')

    for (let i = 0; i < resurs.elementi.length; i++) {
      var element = resurs.elementi[i]
      var file = element.file
      var filename = element.tekst
      //var tip = element.tip
      var id = element.id

      // u Form data dodajemo key/value
      // value moze biti string ili blob(file)
      if (file) {
        formData.append(id, file, filename) // file
      }
      formData.append('elementi[]', JSON.stringify(element)) // string
    }

    //return apiClient.put('/resurs/' + resurs.id, formData)
    return apiClient.post('/resurs/' + resurs.id, formData)
  },
  dajResurse(type, perPage, page, filters) {
    return apiClient.get(
      '/resurs?tip=' +
        type +
        '&_limit=' +
        perPage +
        '&_page=' +
        page +
        '&datum_od=' +
        filters.datum_od +
        '&datum_do=' +
        filters.datum_do
    )
  },
  dajResurs(id) {
    return apiClient.get('/resurs/' + id)
  },
  obrisiResurs(id) {
    return apiClient.delete('/resurs/' + id)
  }
}
